import { Card, Group, Text, Container, SimpleGrid, useMantineColorScheme } from "@mantine/core";
import { useNavigate } from "react-router-dom";
import { Icon } from "tabler-icons-react";

interface CardDetails {
  label: string;
  description: string;
  icon: Icon;
  color: string;
  path: string;
}

interface CardProps {
  elements: CardDetails[];
}

export default function DashboardCards({ elements }: CardProps) {
  const navigate = useNavigate();
  const theme = useMantineColorScheme();

  return (
    <Container fluid className="mt-4 sm:mt-6 px-3 sm:px-6">
      <SimpleGrid cols={{ base: 1, sm: 2 }} spacing={{ base: "md", sm: "lg" }}>
        {elements.map((element) => (
          <Card
            key={element.label}
            component="button"
            onClick={() => navigate(element.path, { relative: "route" })}
            shadow="sm"
            padding="md"
            radius="md"
            withBorder
            className={`w-full text-left transition-colors duration-200 ${theme.colorScheme === "dark" ? "hover:bg-gray-700" : "hover:bg-gray-100"}`}
          >
            <Group wrap="nowrap" gap="sm">
              <element.icon size={32} color={element.color} className="flex-shrink-0" />
              <div className="min-w-0">
                <Text className="truncate">{element.label}</Text>
                <Text size="sm" className="line-clamp-2">{element.description}</Text>
              </div>
            </Group>
          </Card>
        ))}
      </SimpleGrid>
    </Container>
  );
}
